import React from "react";
import styles from "./orders.module.css";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import 'react-tabs/style/react-tabs.css';
import DataTable from 'react-data-table-component';
import ContainerHeader from "common/ContainerHeader";


const Orders = () => {
 

    const data = [
        {
            id: 1,
            ordered_on: 'Wed 10th May 2023 at 00:52',
            order: 'BINGO LINGO - 28th April Fri 28th Apr 2023 at 18:00 Student Ticket',
            reference: 'Fri 23rd Aug',
            state: "karnataka",
            price: 100,
            name: "Matthew"
        },
        {
            id: 2,
            ordered_on: 'Wed 10th May 2023 at 00:52',
            order: 'BINGO LINGO - 28th April Fri 28th Apr 2023 at 18:00 Student Ticket',
            reference: 'Fri 23rd Aug',
            state: "karnataka",
            price: 100,
            name: "Matthew"
        },
    ]

    const columns = [
        {
            name: 'Ordered On   ',
            selector: row => row.ordered_on,
            sortable: true,
            right: true,
            reorder: true, 
        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
            right: true,
            reorder: true,
        },
        {
            name: 'Order',
            selector: row => row.order,
            sortable: true,
            right: true,
            reorder: true,
        },
        {
            name: 'Reference',
            selector: row => row.reference,
            sortable: true,
            right: true,
            reorder: true,
        },
        {
            name: 'State',
            selector: row => row.state,
            sortable: true,
            right: true,
            reorder: true,
        },
        {
            cell: () => <button >view</button>,
        },
    ];




    return (
        <>

            <ContainerHeader label="Sales" showAddButton={false} />
            <div className={styles.container}>

                <Tabs>
                    <TabList >
                        <Tab>Orders</Tab>
                        <Tab>Refund Requested</Tab>
                        <Tab>Approved Refund</Tab>
                        <Tab>Denied Refunds</Tab>
                        <Tab></Tab>
                    </TabList>

                    <TabPanel>
                        <DataTable
                            pagination
                            columns={columns}
                            data={data}
                            selectableRows
                            dense
                        />
                    </TabPanel>
                </Tabs>

            </div>
        </>

    );
};

export default Orders;
